export enum PlcPerformanceCategorie {
  low = 'low',
  medium = 'medium', // default
  high = 'high',
}
